/* eslint-disable react/no-unused-prop-types */
import {
  Box,
  Button,
  Flex,
  FormControl,
  Icon,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  SimpleGrid,
} from '@chakra-ui/react';
import { useField } from 'formik';
import { BiChevronDown } from 'react-icons/bi';

import {
  LIGHT_VEHICLE_COLORS,
  VEHICLE_COLORS,
  VEHICLE_COLOR_HEX,
} from '../constants/vehicleColors';
import { Label } from './formComponents';
import FormErrorMessage from './formComponents/FormErrorMessage';

interface Props {
  name?: string;
  hideLabel?: boolean;
}

const ColorPicker = ({ name = 'color', hideLabel }: Props) => {
  const [field, meta, helpers] = useField(name);

  const { value } = field;
  const { error, touched } = meta;
  const { setValue } = helpers;

  const isInvalid = touched && !!error;

  const getColor = () => {
    if (value === '') {
      if (isInvalid) {
        return 'invalidInputTextRed';
      }
      return 'placeholderGray';
    }
    return LIGHT_VEHICLE_COLORS.has(value as VEHICLE_COLORS) ? 'black' : 'white';
  };
  return (
    <Flex flexDir="column" alignItems="flex-start" w="100%">
      {!hideLabel && <Label letterSpacing="1px">Color</Label>}
      <Box w="100%">
        <Popover variant="picker">
          {({ onClose }: { onClose: () => void }) => {
            return (
              <>
                <PopoverTrigger>
                  <Button
                    w="100%"
                    background={isInvalid ? 'leaseEndRedBG' : 'white'}
                    color={getColor()}
                    h="35px"
                    p="2px"
                    borderRadius="3px"
                    border="1px solid"
                    borderColor={isInvalid ? 'invalidInputBorderRed' : 'grayDarkBackground'}
                    _hover={{ bgColor: isInvalid ? 'leaseEndRedBG' : 'white' }}
                    textAlign="left"
                  >
                    <Flex
                      flexDir="row"
                      h="100%"
                      w="100%"
                      p="3px 0px 3px 10px"
                      borderRadius="3px"
                      justifyContent="space-between"
                      alignItems="center"
                      bgColor={VEHICLE_COLOR_HEX[value as VEHICLE_COLORS]}
                      fontSize="16px"
                      fontWeight="semibold"
                    >
                      <Box>{value === '' ? 'Color' : value}</Box>
                      {value === '' && (
                        <Box
                          borderLeft="1px solid"
                          borderColor="grayDarkBackground"
                          p="0 4px"
                          color="rgb(108, 107, 109)"
                        >
                          <Icon as={BiChevronDown} boxSize="20px" />
                        </Box>
                      )}
                    </Flex>
                  </Button>
                </PopoverTrigger>
                <FormControl isInvalid={isInvalid}>
                  <FormErrorMessage mt="5px" color="leaseEndRed">
                    {error}
                  </FormErrorMessage>
                </FormControl>
                <PopoverContent w="250px">
                  <PopoverBody>
                    <SimpleGrid columns={2} spacing={2}>
                      {Object.entries(VEHICLE_COLOR_HEX).map(([key, c]) => (
                        <Button
                          key={c}
                          background={c}
                          border={key === VEHICLE_COLORS.White ? '1px solid' : 'unset'}
                          borderColor="grayDarkBackground"
                          color={
                            LIGHT_VEHICLE_COLORS.has(key as VEHICLE_COLORS) ? 'black' : 'white'
                          }
                          h="35px"
                          w="110px"
                          p={0}
                          minWidth="unset"
                          _hover={{ background: c }}
                          onClick={() => {
                            setValue(key as VEHICLE_COLORS);
                            onClose();
                          }}
                        >
                          {key}
                        </Button>
                      ))}
                    </SimpleGrid>
                  </PopoverBody>
                </PopoverContent>
              </>
            );
          }}
        </Popover>
      </Box>
    </Flex>
  );
};

export default ColorPicker;
